import request from '../config/axiosConfig';
import {
  GET_LIST_ACCOUNT,
  CREATE_ACCOUNT,
  UPDATE_ACCOUNT,
  DELETE_ACCOUNT,
} from '../constants/apiEndPoint';

const adminService = {
  getList: async (params) => {
    const { data } = await request({ url: GET_LIST_ACCOUNT, method: 'POST', params: params });
    return data?.data.data;
  },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_ACCOUNT, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_ACCOUNT, method: 'POST', data: { id, ...dataBody } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_ACCOUNT, method: 'DELETE', data: { id } });
    return data;
  },
};

export default adminService;
